// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__6Z-WB","label":"Category_label__16Vj-","content":"Category_content__3Pd7I","header":"Category_header__1b_eX","location":"Category_location__3b9LE"};